import { ArrowRight } from "lucide-react";
import { Container } from "@/components/ui/container";
import { Button } from "@/components/ui/button";
import { signupUrl } from "@/lib/content";

export function FinalCTA() {
  return (
    <section aria-labelledby="final-cta-heading" className="py-16 sm:py-24">
      <Container>
        <div className="mx-auto flex max-w-2xl flex-col items-center gap-6 rounded-2xl bg-primary px-6 py-14 text-center text-primary-foreground sm:px-12">
          <h2 id="final-cta-heading" className="text-3xl font-bold tracking-tight sm:text-4xl">
            Ready to make data protection work for your business?
          </h2>
          <p className="max-w-lg text-base leading-relaxed text-primary-foreground/85">
            Create a free account and see where your business stands in your first session.
            No credit card required.
          </p>
          <Button size="lg" variant="secondary" className="bg-white text-primary hover:bg-white/90" asChild>
            <a href={signupUrl}>
              Start Free
              <ArrowRight className="h-4 w-4" aria-hidden="true" />
            </a>
          </Button>
        </div>
      </Container>
    </section>
  );
}
